import styles from "../Components/ProductList.module.css";
import { Link } from "react-router-dom";
const HomeItem = ({ item }) => { 
  const cssStyle = {textDecoration: "none"};  
  // setTimeout(()=>{
  //   document.location.href = '/shop?shopid=2';
  // },1000)
  
  return (
      <>
      <div className={`col-md-2 ${styles.ProductCol}`} key={item.id}>
          <div className="card">
            <div className={styles.cardImgTop}>
              <Link to={`/shop?shopid=${item.id}`} style={cssStyle}><img
                src={`${global.config.live_url}${item.shop_image}`}
                className="card-img-top"
                alt="..." height="200px"
              /></Link>
            </div>
            <div className="card-body">
              <h5 className={`card-title ${styles.productName}`}>
                <span className="product-name"><Link to={`/shop?shopid=${item.id}`} style={cssStyle}>{item.shop_name}</Link></span>
              </h5>
            </div>            
          </div>
        </div>
             
      </>
    );         
      
    
}
export default HomeItem;
